import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { PersistGate } from 'redux-persist/integration/react'

import 'assets/vendors/style'
import 'styles/wieldy.less'
import './app.css'

import store, { persistor } from './appRedux/store'
import Alert from './components/Alert/alert'
import Loading from './components/Loading/loading'
import Routes from './routes/routes'
import { getHealth } from './services/api'

import './config/ReactotronConfig'

const NextApp = () => {
  useEffect(() => {
    const healthCheck = async () => {
      try {
        await getHealth()
      } catch (error) {
        console.log('ERROR (HealthCheck): ', error)
      }
    }

    const intervalId = setInterval(healthCheck, 60000)
    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <Routes />
          <Loading />
          <Alert />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  )
}

export default NextApp
